import React, { FC } from 'react';
import { CustomMultilineInputProps } from './CustomMultilineInputProps';
import { Controller, useFormContext } from 'react-hook-form';
import TextArea from '@ingka/text-area';
import FormField from '@ingka/form-field';
import { returnDisabledStatus } from '../../utils/fieldEditingRules';

const CustomMultilineInput: FC<CustomMultilineInputProps> = ({
  name,
  label,
  dataTestID,
}) => {
  const { control, watch } = useFormContext();
  const disabledFields = watch('disabledFields');
  return (
    <Controller
      render={({ field: { onChange, value }, formState: { errors } }) => (
        <FormField
          valid={!errors[name]}
          className={'green-validation-disabled'}
          shouldValidate={!!errors[name]}
          validation={{
            id: `validation-message-${name}`,
            msg: errors[name]?.message,
            type: 'error',
          }}
        >
          <TextArea
            className={
              returnDisabledStatus(disabledFields, name) && 'read-only-input'
            }
            id={`${name}-id`}
            readOnly={returnDisabledStatus(disabledFields, name)}
            data-testid={dataTestID}
            label={label}
            onChange={onChange}
            value={value ? value : ''}
          />
        </FormField>
      )}
      control={control}
      name={name}
    />
  );
};

export default CustomMultilineInput;
